import Model from "./base/model";

class Address extends Model {
  resourceName() {
    return "addresses";
  }

  fields() {
    return {
      postal_code: "",
      street: "",
      number: "",
      district: "",
      complement: "",
      city: "",
      state: "",
      uf: "",
      latitude: "",
      longitude: "",
      city_id: "",
      country_id: "",
    };
  }
  async update_coordinates(id,data) {
    return this.request(
      this.resourceName() + "/coordinates/" + id,
      "PATCH",
      {},
      data
    );
  }

  async update_city_coordinates(id, data) {
    return this.request(
      `cities/coordinates/${id}`,
      "PATCH",
      {},
      data
    );
  }
}

export default new Address();
